import React from 'react';

interface MetricLinkProps {
    metricKey: string;
    metricName: string;
    metricId?: number;      // Optional: metric ID for backend queries
    areaId: number;         // Current area context (required for filtering)
    onClick?: (metricKey: string, metricId: number | undefined, areaId: number) => void;
    style?: React.CSSProperties;
}

/**
 * Reusable component for rendering metric names as clickable links
 * When clicked, navigates to a report template filtered by metric + area type
 * Similar to AreaLink but for metrics
 */
export const MetricLink: React.FC<MetricLinkProps> = ({ 
    metricKey, 
    metricName, 
    metricId,
    areaId,
    onClick, 
    style 
}) => {
    const handleClick = (e: React.MouseEvent) => {
        e.preventDefault();
        e.stopPropagation();
        if (onClick) {
            onClick(metricKey, metricId, areaId);
        }
    };

    return (
        <a
            href="#"
            onClick={handleClick}
            style={{
                color: '#52c41a',  // Green color for metrics (vs blue for areas)
                textDecoration: 'none',
                cursor: 'pointer',
                fontWeight: 500,
                ...style,
            }}
            onMouseEnter={(e) => {
                e.currentTarget.style.textDecoration = 'underline';
            }}
            onMouseLeave={(e) => {
                e.currentTarget.style.textDecoration = 'none';
            }}
            title={`View ${metricName} reports for this area`}
        >
            {metricName}
        </a>
    );
};

export default MetricLink;
